// SEO / JSON-LD for the About page.
export const aboutJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  '@id': 'https://digitallybaffled.com/about#webpage',
  name: 'About Digitally Baffled — UK Digital Transformation Consultancy',
  url: 'https://digitallybaffled.com/about',
  description: 'Digitally Baffled LTD is a UK-registered digital transformation consultancy founded by Morgan Antell. We help small businesses, tradespeople, and those starting out go digital-first.',
  mainEntity: {
    '@type': 'Organization',
    '@id': 'https://digitallybaffled.com/#organization',
    name: 'Digitally Baffled LTD',
    legalName: 'Digitally Baffled LTD',
    alternateName: 'Digitally Baffled',
    url: 'https://digitallybaffled.com',
    logo: {
      '@type': 'ImageObject',
      url: 'https://digitallybaffled.com/__l5e/assets-v1/f0bdc5e9-161d-4eba-9b27-66e9f15d47b0/site-header-logo.png',
      caption: 'Digitally Baffled LTD logo',
    },
    description: 'Digitally Baffled LTD is a UK-registered digital transformation consultancy (company number 17238376) founded by Morgan Antell. We help small businesses, tradespeople, and those looking to start a business go digital-first — with web design, SEO, AEO & GEO, PPC & Google Ads, social media marketing, and ongoing support.',
    foundingDate: '2024',
    identifier: [
      { '@type': 'PropertyValue', name: 'Companies House Number', value: '17238376' },
    ],
    founder: {
      '@type': 'Person',
      '@id': 'https://digitallybaffled.com/#morgan-antell',
      name: 'Morgan Antell',
      jobTitle: 'Founder & Digital Transformation Consultant',
      worksFor: { '@type': 'Organization', '@id': 'https://digitallybaffled.com/#organization' },
      url: 'https://digitallybaffled.com/about',
      image: 'https://digitallybaffled.com/__l5e/assets-v1/add148a2-15b7-4723-aaf0-4a214e116c09/team-founder.jpg',
      knowsAbout: [
        'Digital Transformation',
        'Web Design',
        'SEO',
        'Answer Engine Optimisation',
        'Generative Engine Optimisation',
        'PPC & Google Ads',
        'Social Media Marketing',
        'Small Business Consultancy',
        'UK Business Registration',
        'GDPR Compliance',
      ],
    },
    employee: {
      '@type': 'Person',
      '@id': 'https://digitallybaffled.com/#morgan-antell',
      name: 'Morgan Antell',
      jobTitle: 'Founder & Digital Transformation Consultant',
    },
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'GB',
      addressRegion: 'England',
    },
    areaServed: { '@type': 'Country', name: 'United Kingdom' },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+447511683542',
      email: 'hello@digitallybaffled.com',
      contactType: 'customer service',
      availableLanguage: 'English',
      areaServed: 'GB',
    },
    knowsAbout: [
      'Digital Transformation',
      'Web Design',
      'App Development',
      'SEO and Answer Engine Optimisation',
      'Generative Engine Optimisation',
      'PPC & Google Ads',
      'Social Media Marketing',
      'Google Business Profile',
      'GDPR Compliance',
      'Small Business Consultancy',
      'UK Company Formation',
    ],
    sameAs: [
      'https://find-and-update.company-information.service.gov.uk/company/17238376',
      'https://www.google.com/maps/place/Digitally+Baffled/@45.7855462,-8.5913112,4z/data=!3m1!4b1!4m6!3m5!1s0x8e1f04c5faa30fcf:0xab1329c6e1625c01!8m2!3d47.73855!4d12.5088275!16s%2Fg%2F11z7jvs5j6',
      'https://www.linkedin.com/company/119624069',
      'https://www.instagram.com/digitally_baffled',
      'https://www.facebook.com/share/1D8QbXPZuP/',
      'https://www.tiktok.com/@digitally_baffled',
    ],
  },
};

export const personJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  '@id': 'https://digitallybaffled.com/#morgan-antell',
  name: 'Morgan Antell',
  jobTitle: 'Founder & Digital Transformation Consultant',
  worksFor: {
    '@type': 'Organization',
    '@id': 'https://digitallybaffled.com/#organization',
    name: 'Digitally Baffled LTD',
    url: 'https://digitallybaffled.com',
  },
  url: 'https://digitallybaffled.com/about',
  image: 'https://digitallybaffled.com/__l5e/assets-v1/add148a2-15b7-4723-aaf0-4a214e116c09/team-founder.jpg',
  description: 'Morgan Antell is the founder of Digitally Baffled LTD, a UK digital transformation consultancy helping small businesses, tradespeople, and new businesses go digital-first.',
  knowsAbout: [
    'Digital Transformation',
    'Web Design',
    'SEO',
    'Answer Engine Optimisation',
    'Generative Engine Optimisation',
    'PPC & Google Ads',
    'Social Media Marketing',
    'Small Business Consultancy',
    'UK Business Registration',
    'GDPR Compliance',
  ],
  nationality: { '@type': 'Country', name: 'United Kingdom' },
};
